import { makeStyles, Spinner, Tab, TabList, tokens } from '@fluentui/react-components';
import React, { useState } from 'react';
import { useProject } from '../../context/ProjectContext';
import MitarbeiterArbeitszeit from './MitarbeiterArbeitszeit';
import MitarbeiterProjektteam from './MitarbeiterProjektteam';

const useStyles = makeStyles({
    container: {
        padding: `0 ${tokens.spacingHorizontalL}`,
        height: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        paddingTop: tokens.spacingVerticalL,
        borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
        marginBottom: tokens.spacingVerticalL,
    },
    title: {
        margin: 0,
        marginBottom: tokens.spacingVerticalM,
        fontSize: tokens.fontSizeHero800,
    },
    content: {
        flex: 1,
        overflow: 'auto',
    },
    emptyState: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        minHeight: '100px',
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase300,
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        textAlign: 'center',
        margin: '10px',
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        minHeight: '300px',
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        minHeight: '300px',
    },
});

const Mitarbeiter: React.FC = () => {
    const styles = useStyles();
    const { project, isLoading, error } = useProject();
    const [selectedTab, setSelectedTab] = useState<'projektteam' | 'arbeitszeit'>('projektteam');

    const renderContent = () => {
        switch (selectedTab) {
            case 'projektteam':
                return <MitarbeiterProjektteam project={project} />;
            case 'arbeitszeit':
                return <MitarbeiterArbeitszeit project={project} />;
            default:
                return <MitarbeiterProjektteam project={project} />;
        }
    };

    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.loadingContainer}>
                    <Spinner label="Project is loading..." labelPosition="below" />
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.errorContainer}>
                    <h2 style={{ color: tokens.colorNeutralForeground3 }}>
                        {error}
                    </h2>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1 className={styles.title}>{project?.title || 'Project Details'}</h1>
                <TabList
                    selectedValue={selectedTab}
                    onTabSelect={(_, data) => setSelectedTab(data.value as 'projektteam' | 'arbeitszeit')}
                >
                    <Tab value="projektteam">Team</Tab>
                    <Tab value="arbeitszeit">Hours</Tab>
                </TabList>
            </div>
            <div className={styles.content}>
                {renderContent()}
            </div>
        </div>
    );
};

export default Mitarbeiter;
